var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForumIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/svg",
  className: "MuiSvgIcon-root menu-button_color",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z",
  fill: "#FFFFFF"
})));
export { SvgForumIcon as ReactComponent };
export default __webpack_public_path__ + "b48e844bff56bec65e504033d54362e5.svg";